import {Grid} from '@material-ui/core';
import Button from 'components/button';
import {DateInput, Field, Form, Input, Textarea} from 'components/forms';
import {refundForm} from 'components/forms/decorators';
import {gt} from 'components/forms/form/validators';
import NewOptionsSidebar from 'components/new-options-sidebar';
import {isMobile} from 'core/utils';
import createCLDealerRefundOrderMutation from 'graphql/mutations/orders/create-cl-dealer-refund-order.gql';
import moment from 'moment';
import React, {Component} from 'react';
import styles from '../styles.css';

@refundForm(createCLDealerRefundOrderMutation)
export default class CLDealerRefundCreate extends Component {
    render() {
        return (
            <div className={styles.root}>
                <NewOptionsSidebar
                    refundType='cl'
                    userType='dealer'
                    links={['refund', 'kits', 'trialSigns']}
                />

                <p className={styles.title}>Solicitud de Presupuesto de Jornada</p>
                <p className={styles.subtitle}>Para automatización de gastos</p>
                <div className={styles.formContainer}>
                    <Form
                        fields={[
                            {key: 'date'},
                            {key: 'estimatedAmount', validators: [gt(0)]},
                            {key: 'attendees', validators: [gt(0)]},
                            {key: 'notes', required: false},
                        ]}
                        errors={this.props.errors}
                        onSubmit={this.props.onSubmit}>
                        {({getFieldProps, renderErrors, isValid}) => (
                            <Grid container direction='column' spacing={3}>
                                <Grid item container direction={isMobile() ? 'column' : 'row'} spacing={1} wrap='nowrap' alignItems='flex-start' >
                                    <Grid item xs={12} md={4} style={{width: '100%'}}>
                                        <Field label='Fecha estimada' className={styles.input}>
                                            <DateInput min={moment().format('YYYY-MM-DD')} {...getFieldProps('date')} />
                                            {renderErrors('date')}
                                        </Field>
                                    </Grid>
                                    <Grid item xs={12} md={4} style={{width: '100%'}}>
                                        <Field label='Presupuesto estimado total' className={styles.input}>
                                            <Input type='number' {...getFieldProps('estimatedAmount')} />
                                            {renderErrors('estimatedAmount')}
                                        </Field>
                                    </Grid>
                                    <Grid item xs={12} md={4} style={{width: '100%'}}>
                                        <Field label='Cantidad estimada de invitados' className={styles.input}>
                                            <Input type='number' {...getFieldProps('attendees')} />
                                            {renderErrors('attendees')}
                                        </Field>
                                    </Grid>
                                </Grid>
                                <Grid item sx={{mt: 2}}>
                                    <Field label='Comentarios para Nidera' className={styles.input}>
                                        <Textarea {...getFieldProps('notes')} />
                                        {renderErrors('notes')}
                                    </Field>
                                </Grid>
                                <Grid item>
                                    {renderErrors('__all__')}
                                </Grid>
                                <Grid item>
                                    <Form.Actions>
                                        <Grid container justify='flex-end'>
                                            <Grid item xs={4}>
                                                <Button theme='yellow' fullWidth className={styles.button} disabled={!isValid() || this.props.loading}>
                                                    {this.props.loading ? 'ENVIANDO...' : 'ENVIAR'}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Form.Actions>
                                </Grid>
                            </Grid>
                        )}
                    </Form>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/refunds/cl-dealer/refund/index.js